export default [
  {
    prop: 'order_id',
    label: '客户订单号',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'trade_no',
    label: '平台订单号',
    minWidth: 160,
    tooltip: true
  },
  {
    prop: 'merchant_id',
    label: '商户号',
    minWidth: 120,
    tooltip: true
  },
  {
    prop: 'appid',
    label: 'APPID',
    minWidth: 180,
    tooltip: true
  },
  {
    prop: 'openid',
    label: '提现账号',
    minWidth: 180,
    tooltip: true
  },
  {
    prop: 'pay_amount',
    label: '提现金额',
    minWidth: 120,
    tooltip: true
  },
  {
    prop: 'name',
    label: '姓名',
    minWidth: 80,
    tooltip: true
  },
  {
    prop: 'out_batch_no',
    label: '平台批次号',
    minWidth: 170,
    tooltip: true
  },
  {
    prop: 'create_time',
    label: '创建时间',
    minWidth: 170,
    tooltip: true
  },
  {
    prop: 'pay_status',
    label: '状态',
    width: '80px'
  }
]
